import './style.css';

const CustomPagination = ({ itemsPerPage = 10, totalItems = 0, currentPage = 1, onPageChange }) => {
    const safeItemsPerPage = Number(itemsPerPage) || 10;
    const safeTotalItems = Number(totalItems) || 0;
    const safeCurrentPage = Number(currentPage) || 1;
    const totalPages = safeItemsPerPage > 0 ? Math.ceil(safeTotalItems / safeItemsPerPage) : 0;
    const pageNumbers = [];

    const startItem = safeTotalItems === 0 ? 0 : (safeCurrentPage - 1) * safeItemsPerPage + 1;
    const endItem = safeTotalItems === 0 ? 0 : Math.min(safeCurrentPage * safeItemsPerPage, safeTotalItems);
  
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  
  const handlePrev = () => {
    if (safeCurrentPage > 1) {
      onPageChange(safeCurrentPage - 1);
    }
  };

  const handleNext = () => {
    if (safeCurrentPage < totalPages) {
      onPageChange(safeCurrentPage + 1);
    }
  };

  return (
    <div className="paginationBar align-items-center">
      <p>Showing {endItem} out of {safeTotalItems} Entries</p>
      {/* <p>Showing {startItem}-{endItem} out of {safeTotalItems} Entries</p> */}
      <ul>
        <li>
          <button 
            onClick={handlePrev} 
            disabled={safeCurrentPage === 1 || totalPages === 0}
            className={safeCurrentPage === 1 || totalPages === 0 ? 'disabled' : ''}
          >
            Prev
          </button>
        </li>
        {pageNumbers.map((pageNumber) => (
          <li key={pageNumber}>
            <button 
              onClick={() => onPageChange(pageNumber)}
              className={safeCurrentPage === pageNumber ? 'active' : ''}
            >
              {pageNumber}
            </button>
          </li>
        ))}
        <li>
          <button 
            onClick={handleNext} 
            disabled={safeCurrentPage >= totalPages || totalPages === 0}
            className={safeCurrentPage >= totalPages || totalPages === 0 ? 'disabled' : ''}
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  );
  };
  
  export default CustomPagination;

